module.exports = __webpack_public_path__ + "img/laudo_semanal.ae4027e3.svg";